import { render, staticRenderFns } from "./ClaimLoadingState.vue?vue&type=template&id=1ce0c4d0&scoped=true&lang=pug&"
import script from "./ClaimLoadingState.vue?vue&type=script&lang=js&"
export * from "./ClaimLoadingState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce0c4d0",
  null
  
)

export default component.exports